import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import de from 'dayjs/locale/de'
import localizedFormat from 'dayjs/plugin/localizedFormat'

dayjs.locale(de, null, true)
dayjs.extend(utc)
dayjs.extend(localizedFormat)

export { dayjs as default }
